module.exports = __webpack_public_path__ + "static/media/20.67ab37fa.svg";